import type { LinkType } from '../types';

export const getBlogAnalyticsProperties = ({
  id,
  title,
  slug,
  excerpt,
}: {
  id: string;
  title: string;
  slug: string;
  excerpt?: string;
}) => {
  return {
    blog_id: id,
    blog_title: title,
    blog_slug: slug,
    blog_excerpt: excerpt,
  };
};

export const getProductCardAnalyticsProperties = ({
  name,
  price,
}: {
  name: string;
  price?: number;
}) => {
  return {
    product_name: name,
    product_price: price,
  };
};

export const getAdBannerAnalyticsProperties = ({
  id,
  name,
  linkType,
  linkUrl,
  hasContactForm = false,
}: {
  id: string;
  name: string;
  linkType: LinkType | null;
  linkUrl?: string;
  hasContactForm: boolean;
}) => {
  return {
    ad_banner_id: id,
    ad_banner_name: name,
    ad_banner_link_type: linkType,
    ad_banner_link_url: linkUrl,
    ad_banner_has_contact_form: hasContactForm,
  };
};
